import { gsap } from 'gsap';

if (document.querySelector('.services-sec__row-marquee')) {
  let currentScroll = window.pageYOffset;
  let isScrollingDown = true;
  let scrollTimeout;

  document.querySelectorAll('.services-sec__row-marquee').forEach((row) => {
    const track = row.querySelector('.services-sec__row-track');
    const content = track.querySelector('.services-sec__row-content');

    const clone = content.cloneNode(true);
    track.appendChild(clone);
    track.appendChild(clone);
    track.appendChild(clone);

    const contentWidth = content.offsetWidth;

    gsap.set(track, { x: -contentWidth });

    const tween = gsap.to(track, {
      x: `-=${contentWidth}`,
      duration: 135,
      ease: 'linear',
      repeat: -1,
      modifiers: {
        x: gsap.utils.unitize((x) => parseFloat(x) % contentWidth),
      },
    });

    tween.totalProgress(0.5);

    window.addEventListener('scroll', () => {
      const newScroll = window.pageYOffset;
      isScrollingDown = newScroll > currentScroll;
      currentScroll = newScroll;

      gsap.to(tween, {
        timeScale: isScrollingDown ? 2 : -2,
        overwrite: true,
        duration: 0.2,
      });

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        gsap.to(tween, {
          timeScale: isScrollingDown ? 1 : -1,
          duration: 0.5,
          ease: 'power2.out',
        });
      }, 300);
    });
  });
}
